import { ToolGeneratorLayoutPrimary, ChatActions, ChatOptions } from 'ui'
import React, { useContext } from 'react'
// import ChatOptions from './chatOptions'
import { useSelector } from 'react-redux'
import { useTranslate } from '@tolgee/react'
import { useDispatch } from 'react-redux'
import { ViewContext } from 'components/lib'
import {
  SelectChatBotInputValues,
  SelectChatBotListData,
  SelectChatBotSettings,
  setChatBotInputValues,
  setClearFields,
  setSelectedChatBotSettings,
  setSelectedChatBotValues,
} from 'store/account/chatBot'
import DuplicateModalView from 'toolComponents/chat-bot/library/DuplicateModalView'
import { useVoices } from 'components/hooks/voices'
import usePanelSize from 'components/hooks/panelSize'
import { useLanguages } from 'components/hooks/language'
import ImageDropZone from 'toolComponents/image/ImageDropZone'
import aiController from 'helpers/AIController'
import { ChatbotPublishing } from './chatBotPublishing'
import { ContextMenu } from 'components/context-menu'

const ChatGenerator = ({
  isShowAdvanced,
  setIsShowAdvanced,
  isShowPublishing,
  setIsShowPublishing,
  handleGenerateChatBot,
  handleFileUpload,
  documentContext,
  publishState,
  setPublishState,
  chatbotServerState,
  isEditMode,
  loadingState,
  handleResetToServerState,
  isUpdatePending,
  isDraftSaved,
  chatbotDraftServerState,
  setModalData,
  isDraft,
}) => {
  const { t } = useTranslate()
  const dispatch = useDispatch()
  const context = useContext(ViewContext)
  const voices = useVoices()
  const isPanelLarge = usePanelSize('chatbot', 520)

  const chatBotInputValues = useSelector(SelectChatBotInputValues)
  const chatBotList = useSelector(SelectChatBotListData)
  const chatBotSettings = useSelector(SelectChatBotSettings)

  const handleDispatchFieldValue = (params) => {
    dispatch(setChatBotInputValues(params))
  }

  return (
    <ToolGeneratorLayoutPrimary
      options={
        <ChatOptions
          isShowAdvanced={isShowAdvanced}
          setIsShowAdvanced={setIsShowAdvanced}
          isShowPublishing={isShowPublishing}
          setIsShowPublishing={setIsShowPublishing}
          handleFileUpload={handleFileUpload}
          documentContext={documentContext}
          publishState={publishState}
          setPublishState={setPublishState}
          chatBotInputValues={chatBotInputValues}
          chatbotServerState={chatbotServerState}
          chatbotDraftServerState={chatbotDraftServerState}
          setModalData={setModalData}
          isUpdatePending={isUpdatePending}
          isDraftSaved={isDraftSaved}
          handleGenerateChatBot={handleGenerateChatBot}
          handleDispatchFieldValue={handleDispatchFieldValue}
          voices={voices}
          isPanelLarge={isPanelLarge}
          useLanguages={useLanguages}
          ImageDropZone={ImageDropZone}
          aiController={aiController}
          ChatbotPublishing={ChatbotPublishing}
          t={t}
          ContextMenu={ContextMenu}
          context={context}
        />
      }
      actions={
        <ChatActions
          handleGenerateChatBot={handleGenerateChatBot}
          isEditMode={isEditMode}
          loadingState={loadingState}
          handleResetToServerState={handleResetToServerState}
          isUpdatePending={isUpdatePending}
          isDraftSaved={isDraftSaved}
          isDraft={isDraft}
          setModalData={setModalData}
          chatBotList={chatBotList}
          chatBotInputValues={chatBotInputValues}
          chatBotSettings={chatBotSettings}
          context={context}
          t={t}
          handleUndoReset={() => {
            dispatch(setSelectedChatBotValues(chatBotInputValues))
            dispatch(setSelectedChatBotSettings(chatBotSettings))
          }}
          handleClearFields={() => dispatch(setClearFields())}
          DuplicateModalView={DuplicateModalView}
        />
      }
    />
  )
}

export default ChatGenerator
